import { useState, useEffect } from "react";
import {
  DESKTOP_4K_SIZE_SCREEN,
  LAPTOP_SIZE_SCREEN,
  MOBILE_SIZE_SCREEN,
  SMALL_MOBILE_SIZE_SCREEN,
  TABLET_SIZE_SCREEN,
} from "../constants";

const breakpoints = {
  smallMobile: 320,
  mobile: 480,
  tablet: 768,
  laptop: 1024,
};

export const useDeviceSize = () => {
  const [deviceSize, setDeviceSize] = useState("desktop");

  useEffect(() => {
    const updateDeviceSize = () => {
      if (
        window.matchMedia(`(max-width: ${breakpoints.smallMobile}px)`).matches
      ) {
        setDeviceSize(SMALL_MOBILE_SIZE_SCREEN);
      } else if (
        window.matchMedia(`(max-width: ${breakpoints.mobile}px)`).matches
      ) {
        setDeviceSize(MOBILE_SIZE_SCREEN);
      } else if (
        window.matchMedia(`(max-width: ${breakpoints.tablet}px)`).matches
      ) {
        setDeviceSize(TABLET_SIZE_SCREEN);
      } else if (
        window.matchMedia(`(max-width: ${breakpoints.laptop}px)`).matches
      ) {
        setDeviceSize(LAPTOP_SIZE_SCREEN);
      } else {
        setDeviceSize(DESKTOP_4K_SIZE_SCREEN);
      }
    };

    updateDeviceSize();

    window.addEventListener("resize", updateDeviceSize);

    return () => window.removeEventListener("resize", updateDeviceSize);
  }, []);

  return deviceSize;
};
